import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loadingWrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/icon/icon.png",
    alt: "Dishcover",
    class: "logo logo-color",
    id: "loadingLogo"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot-flashing" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "ion-padding loadingModalContent" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}